import qs from 'qs'

const fields = [
  'title',
  'thickness',
  'width_in_mm'
]

export const queryPublicationEntryBySlug = (options: QueryBySlugOrIdOptions) => {
  const searchKey = strapiGetI18nSlug(options.locale)

  const query = qs.stringify(
    {
      publicationState: options?.publicationState || 'live',
      filters: {
        slugs: {
          [searchKey]: {
            $eq: options.slug
          }
        }
      },
      fields,
      populate: {
        ...queryFragmentCollectionTypeDefault,
        ...queryFragmentBlocks,
        cover_image: true
      }
    },
    {
      encodeValuesOnly: true
    }
  )

  return `publication-entries?${query}`
}
